export default __webpack_public_path__ + "images/assets/19e4a3dadb0a346fc4d0d7732f70dc72.svg";